'use client';

import { type ReactNode } from 'react';

import { cn } from '@ps/ui/utils';

type ActionButtonProps = {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  label?: string;
  bgColor?: string;
  size?: number;
};

export function ActionButton({
  children,
  onClick,
  disabled,
  className,
  label,
  bgColor = 'rgba(0, 0, 0, 0.3)',
  size = 50,
}: ActionButtonProps) {
  return (
    <div
      className={cn('flex flex-col items-center', className)}
      style={{ width: size }}
    >
      <button
        type="button"
        onClick={e => {
          e.stopPropagation();
          onClick?.();
        }}
        disabled={disabled}
        className={cn(
          'flex items-center justify-center overflow-hidden rounded-full transition-transform',
          'hover:scale-110 active:scale-95',
          disabled && 'pointer-events-none opacity-50',
        )}
        style={{
          width: size,
          height: size,
          backgroundColor: bgColor,
        }}
      >
        {children}
      </button>
      {label && (
        <span
          className="text-content-1 text-center"
          style={{
            fontSize: 8,
            lineHeight: '10px',
            fontWeight: 600,
            fontFamily: 'var(--font-dm-sans), "DM Sans", sans-serif',
            fontStyle: 'normal',
            marginTop: 4,
          }}
        >
          {label}
        </span>
      )}
    </div>
  );
}
